import { useEffect, useMemo, useRef } from 'react'

import { useDecodedAccessToken } from '@b-stock/fe-core/bstock-next/components'

export function useCardAddScope(accountId: string, accessToken: string) {
  const identity = useDecodedAccessToken()
  // Token rotation preserves the person/account. Logout or an identity change
  // invalidates old callbacks even if that person later signs back in.
  const authenticated = !!accessToken && !!identity?.personId
  const scopeKey = JSON.stringify([
    accountId,
    identity?.accountId,
    identity?.personId,
    authenticated,
  ])
  const token = useRef(accessToken)
  token.current = accessToken // oxlint-disable-line react/refs
  const scope = useRef({ scopeKey, mounted: true })
  // oxlint-disable-next-line react/refs
  if (scope.current.scopeKey !== scopeKey) {
    scope.current = { scopeKey, mounted: true } // oxlint-disable-line react/refs
  }
  const current = scope.current // oxlint-disable-line react/refs
  useEffect(() => {
    current.mounted = true
    return () => {
      current.mounted = false
    }
  }, [current])
  return useMemo(() => {
    const isCurrent = () =>
      authenticated && scope.current === current && current.mounted
    return {
      scopeKey,
      isCurrent,
      getAccessToken: () => (isCurrent() ? token.current : ''),
    }
  }, [authenticated, current, scopeKey])
}
